export default __webpack_public_path__ + "static/media/UploadedKyc.e6f0215f.svg";